import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";

export class IsTGRFreespinsTriggered extends Decision {

    public evaluate(): Exit {
        const rootRecord = gameState.getCurrentGame().getRootRecord();
        const fsWinResult: boolean = gameState.currentRecordHasFreespinWinResults();
        const hasChildren: boolean = rootRecord.hasChildren && rootRecord.children.length > 0;
        const fsUnfinished: boolean = rootRecord.currentChildIndex !== rootRecord.children.length - 1;
        if (fsWinResult && (!hasChildren || fsUnfinished)) {
            return Exit.True;
        }
        return Exit.False;
    }
}
